import React from 'react';
import { numberWithCommas, roundedNumber } from 'helpers/Utils.js';
import moment from 'moment';
import {
  StyledLegendList,
  StyledLegendItem,
  StyledTooltipContainer,
  StyledTooltipLabel,
  StyledTooltipValue,
} from './styled.js';

/* Utils */
export const getEntityName = (entityId, entities) => {
  const entity = entities.find(e => e.public_id === entityId);

  if (entity) {
    return entity.name;
  }
};

const sortByLargest = data => data.sort((a, b) => b.value - a.value);

/* Custom Tooltips */
export const MultiLineCustomTooltip = (props) => {
  const { active, entities } = props;

  if (active) {
    const { payload = [], label, labelFormatter = el => el } = props;
    const sortedData = sortByLargest(payload);

    return (
      <StyledTooltipContainer className="custom-tooltip-container">
        <StyledTooltipLabel>{labelFormatter(label)}</StyledTooltipLabel>
        {sortedData.map((data, index) => (
          <StyledTooltipValue
            key={`tooltip-item-${index}`}
            className={`custom-tooltip-container__value--${data.dataKey}`}
          >{`${getEntityName(data.dataKey, entities)}: ${numberWithCommas(data.value)}`}</StyledTooltipValue>
        ))}
      </StyledTooltipContainer>
    );
  }
  return null;
};

export const SingleLineCustomTooltip = (props) => {
  const { active, entities, dataKey } = props;

  if (active) {
    const { payload = [] } = props;
    const value = payload[0].value || '';
    const entryPayload = payload[0].payload;
    const index = entities.map(e => e[dataKey]).indexOf(entryPayload[dataKey]);

    return (
      <StyledTooltipContainer className="custom-tooltip-container">
        <StyledTooltipValue
          key={`tooltip-item-${index}`}
          className={`custom-tooltip-container__value--${entryPayload[dataKey]}`}
        >{`${getEntityName(entryPayload[dataKey], entities)}: ${numberWithCommas(value)}`}</StyledTooltipValue>
      </StyledTooltipContainer>
    );
  }
  return null;
};

/* Custom Legend */
export const EntityLegend = (props) => {
  const { payload, top } = props;
  return (
    <StyledLegendList top={top}>
      {payload.map((entry, index) => (
        <StyledLegendItem key={`legend-item-${index}`} idx={index + 1}>
          {entry.payload.entityName || entry.value}
        </StyledLegendItem>
        ))}
    </StyledLegendList>
  );
};


/**
 * Parse timestamp and return formatted date.
 * @param  {Number} timestamp Timestamp
 * @return {String}           `Month day` formatted string.
 */
export const xTickFormatter = (timestamp, timeInterval) => {
  if (timeInterval === 'month' || timeInterval === 'all') {
    return moment(timestamp).format("MMM [']YY");
  } else if (timeInterval === 'full') {
    return moment(timestamp).format('MMM DD[,] YYYY');
  }

  return moment(timestamp).format('MMM DD');
};

export const yTickFormatter = tick => roundedNumber(tick);

export const entityListValidate = ({ entities = [], data = [] }) => {
  // Empty data or missing entity keys will return invalid
  if (!data.length || !entities.length) return false;
  // From here we'll check each key against the data set and ensure there's at least ONE positive int for a time period
  const reduced = entities.filter(
    ({ public_id: key }) => data.filter((dataSet) => dataSet[key]).reduce((total, dataSet) => total + dataSet[key], 0) > 0
  );
  return !!reduced.length;
};
